module.exports = __webpack_public_path__ + "static/logo-desktop-156ac36ade6e54b62fcf144f16c1b727.svg";